import { EERIE, OBSIDIAN } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import useLocale from 'developer-docs-shared-components/hooks/useLocale';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { selectSearchQuery } from '../../selectors/searchState';
import OldSiteRedirectAlert from './OldSiteRedirectAlert';
import { SeeEnglishResults } from './SeeEnglishResults';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NoResultsContainer = styled.div.withConfig({
  displayName: "NoResultsFound__NoResultsContainer",
  componentId: "sc-1jr77fb-0"
})(["", ""], ({
  inDropdown
}) => inDropdown ? `
    padding-top: 36px;
    padding-bottom: 28px;
    color:${OBSIDIAN};
    font-size: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  ` : `
    padding-top: 40px;
    padding-bottom: 56px;
  `);
const NoResultsDropdownHeader = styled.h5.withConfig({
  displayName: "NoResultsFound__NoResultsDropdownHeader",
  componentId: "sc-1jr77fb-1"
})(["color:", ";"], EERIE);
const InlineMediumSizeIcon = styled(UIIcon).attrs({
  size: 'medium',
  color: EERIE
}).withConfig({
  displayName: "NoResultsFound__InlineMediumSizeIcon",
  componentId: "sc-1jr77fb-2"
})(["position:relative;left:8px;top:6px;"]);
function NoResultsFound({
  query,
  inDropdown
}) {
  const locale = useLocale();
  const NoResultsHeader = ({
    children
  }) => {
    return inDropdown ? /*#__PURE__*/_jsx(NoResultsDropdownHeader, {
      children: children
    }) : /*#__PURE__*/_jsx(View, {
      paddingBlockEnd: "800",
      as: "div",
      children: children
    });
  };
  return /*#__PURE__*/_jsxs(NoResultsContainer, {
    inDropdown: inDropdown,
    "data-test-id": "no-results-found",
    children: [locale !== 'en-us' && /*#__PURE__*/_jsx("div", {
      className: `${inDropdown ? 'p-bottom-2' : 'p-bottom-8'}`,
      children: /*#__PURE__*/_jsx(SeeEnglishResults, {
        query: query
      })
    }), /*#__PURE__*/_jsxs(NoResultsHeader, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-ui.search.noResultsFound",
        options: {
          query
        }
      }), /*#__PURE__*/_jsx(InlineMediumSizeIcon, {
        name: "emojiLineSad"
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: `${inDropdown ? 'p-top-2' : 'p-top-8 p-bottom-14'}`,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-ui.search.rewordYourQuery"
      })
    }), /*#__PURE__*/_jsx(OldSiteRedirectAlert, {})]
  });
}
const mapStateToProps = state => {
  return {
    query: selectSearchQuery(state)
  };
};
export default connect(mapStateToProps)(NoResultsFound);